import { EmployeeStatus } from '../client/clientTypes';
export const createFakeEmployee = (id, lastName, email) => ({
    id: id,
    employerId: 'employerId',
    profile: {
        name: {
            lastName: lastName,
            firstName: lastName,
        },
        inn: Array(12).fill(id).join(''),
        email: email,
    },
    meta: {
        creationDate: '2012-04-23',
        version: 0,
    },
    activePeriod: {},
    status: EmployeeStatus.Active,
    workingEvents: {
        sentCount: 1,
    },
    requisites: {},
});
